import { render, staticRenderFns } from "./CopyableId.vue?vue&type=template&id=1e98247e&scoped=true"
import script from "./CopyableId.vue?vue&type=script&lang=js"
export * from "./CopyableId.vue?vue&type=script&lang=js"
import style0 from "./CopyableId.vue?vue&type=style&index=0&id=1e98247e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e98247e",
  null
  
)

export default component.exports